<template>
  <div id="soundcloudWrapper" class="fixed-bottom-mix">
    <div id="soundcloudModule"
         ref="soundcloudModule"
         class="d-flex flex-row align-items-center slide-in-bottom mixcloud-bg justify-content-between audioPlayerModule">
      <div class="snd-player-logo">
        <LogoPlayer/>
      </div>
      <div id="PlayerSoundCloud" ref="playerSoundCloudContainer" class="player-soundcloud-container">
        <div id="snd" ref="playerSoundCloudIframe"/>
      </div>
      <div class="player-info d-flex h-100 align-items-center">
        <a v-if="soundcloudUrl" class="snd-url" :href="soundcloudUrl" target="_blank">
          <IconSoundcloud/>
        </a>
        <div class="player-component-info">
          <div class="player-component-info__item">
            <span>EPISODE</span>
            <router-link class="mvmnt-link" :to="{ path: '/show/' + episodePermlink }">
              {{ episodeTitle }}
            </router-link>
          </div>
          <div v-if="getArtist" class="player-component-info__item">
            <span>ARTIST PROFILE</span>
            <router-link class="mvmnt-link" :to="{ path: '/artist/' + getArtist.permlink }">
              {{ getArtist.name }}
            </router-link>
          </div>
        </div>
        <div class="player-close-button bd-highlight">
          <button
            type="button"
            aria-label="Close"
            class="close close-mix"
            @click="destroySoundcloud()"
          >
            <IconClose/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SoundcloudPlayer from "@/components/players/SoundcloudPlayer/SoundcloudPlayer";
import IconClose from "@/components/svg/IconClose.vue";
import {mapState} from "vuex";
import IconSoundcloud from "@/components/svg/IconSoundcloud.vue";
import LogoPlayer from "@/components/players/SoundcloudPlayer/LogoPlayer.vue";

export default {
  name: "PlayerSoundCloud",
  components: {LogoPlayer, IconSoundcloud, IconClose},
  data() {
    return {
      soundcloudInstance: null
    }
  },
  computed: {
    ...mapState({
      episodeTitle() {
        return this.$store.getters['audioPlayer/getEpisodeTitle'];
      },
      episodeUrl() {
        return this.$store.getters['audioPlayer/getEpisodeUrl'];
      },
      episodePermlink() {
        return this.$store.getters['audioPlayer/getEpisodePermlink']
      },
      soundcloudUrl() {
        return this.$store.getters['audioPlayer/getSoundcloudUrl'];
      },
      trigger() {
        return this.$store.getters['audioPlayer/getTrigger'];
      },
      audioPlayerData() {
        return this.$store.getters['audioPlayer/getAudioPlayerData'];
      },
      getArtist() {
        return this.$store.getters['audioPlayer/getArtist'];
      }
    })
  },
  watch: {
    trigger() {
      this.$store.getters['audioPlayer/getAudioPlayerIsPlaying'] ? this.soundcloudInstance.SndWidget.pause() : this.soundcloudInstance.SndWidget.play();
    },
    episodeUrl() {
      this.destroySoundcloudInstance();
      this.$store.dispatch('audioPlayer/destroy');
      this.createSoundcloud();
    }
  },
  async mounted() {
    await this.$nextTick();
    await this.createSoundcloud();
  },
  beforeDestroy() {
    this.$store.commit('audioPlayer/setSoundcloudInstance', null);
  },
  methods: {
    async createSoundcloud() {
      if (this.$el.querySelector('snd-player')) return;
      this.soundcloudInstance = await SoundcloudPlayer.initialize(this.episodeUrl);
      this.soundcloudInstance.SndWidget.play();
      this.$store.commit('audioPlayer/setSoundcloudInstance', this.soundcloudInstance);
      this.soundcloudInstance.SndWidget.onPlay(() => {
        this.$store.commit('audioPlayer/setIsPlaying', true);
      })
      this.soundcloudInstance.SndWidget.onPause(() => {
        this.$store.commit('audioPlayer/setIsPlaying', false);
      })
      this.soundcloudInstance.SndWidget.onLoading(() => {
        this.$store.commit('audioPlayer/setIsPlaying', false);
      })
      this.$refs.playerSoundCloudContainer.append(this.soundcloudInstance)
    },
    destroySoundcloudInstance() {
      this.soundcloudInstance.destroy();
      while (this.$refs.playerSoundCloudIframe.firstChild) {
        this.$refs.playerSoundCloudIframe.removeChild(this.$refs.playerSoundCloudIframe.firstChild);
      }
      this.soundcloudInstance = null;
      this.$store.commit('audioPlayer/setSoundcloudInstance', null);
    },
    destroySoundcloud() {
      this.$store.commit('audioPlayer/setProvider', null);
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/assets/sass/components/players/player-audio";
@import "@/assets/sass/abstracts/_variables.scss";

#snd {
  display: none !important;
}

.snd-url {
  display: flex;
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  color: $c_medium_grey;
  margin-right: 20px;
  margin-left: 10px;
  transition: all .3s ease;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  &:hover {
    color: $c_base;
  }

  @include media-breakpoint-down(lg) {
    width: 30px;
    height: 30px;
  }
}

.player-soundcloud-container {
  width: 50%;
  @include media-breakpoint-down(md) {
    width: 100%;
  }
}
</style>